const utils = {
    /**
     * 验证身份证号码是否正确
     * @param idNum
     */
    checkIdNum: (idNum: string) => {
        const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        return reg.test(idNum);
    },
};


export default utils;
